import script from "./ExpenseDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseDetailView.vue?vue&type=style&index=0&id=a9f20312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f20312"]])

export default __exports__